import Singleton from './Singleton'
import {useEffect, useState} from 'react'

export class Languages extends Singleton {
  static config = {
    default_language: 'cs-CZ'
  }

  static _languages = [
    {key: 'cs-CZ', name: 'Čeština'},
    {key: 'en-US', name: 'English'}
  ]

  data = {}

  isDataLoadingPromise = null

  /**
   *
   * @param {App} app
   */
  constructor(app) {
    super()

    this.$app = app || window.$app

    // Language check
    if(this.$app.$storage.local.get('active_language') === null)
      this.$app.$storage.local.set('active_language', Languages.config.default_language)

  }

  async loadData() {
    let translations = await this.getData()
    this.data = {...this.data, ...translations}
  }

  async getData() {
    const active_lang = this.$language()



    const data = await this.$app.$directus('texts', {
      fields: ['*', {translations: ['languages_code', 'value']}],
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': active_lang}
          }
        }
      },
      meta: 'filter_count'
    })

    return {[active_lang]: data.reduce((acc, cur) => {

      acc[cur.key] = cur.translations[0]?.value || null //cur.translations.map((lng) => {
        //return {[lng.languages_code]: lng.value}
      //})
      return acc
    }, {})}
  }

  async isLoading() {
    if(this.isDataLoadingPromise === null)
      this.isDataLoadingPromise = (async () => {
        await this.loadData()
      })()

    await this.isDataLoadingPromise

  }

  async $t(...keys) {

    await this.isLoading()

    return this._findByKeys(keys)
  }

  async $tc(...args) {

    const count = args.pop()
    const plurals = this._findByKeys(args, this.data).split('|').map(item => item.trim())

    if(count === 1)
      return plurals[0]
    if(plurals.length === 3 && (4 < count || count === 0))
      return plurals[2]

    return plurals[1]
  }

  useTranslations() {

  }

  $language(active = null) {
    if(active)
      this.$app.$storage.local.set('active_language', active)

    return this.$app.$storage.local.get('active_language')
  }

  _findByKeys(keys, data = this.data[this.$language()]) {

    // Result key found
    if(keys.length === 0)
      return data

    if(data[keys[0]] !== undefined) {
      let original = keys.shift()
      return this._findByKeys(keys, data[original])
    } else {
      console.warn(`JS lang key ${keys} not exist`)
      return `[key ${keys}]`
    }
  }
}

export async function _$t(key) {
  const text = await $language().$t(key)

  return text || ""
}

export function $t({_, children}) {
  const [text, setText] = useState(null)

  useEffect(() => {
    (async () => {

      return await $language().$t(_)

    })().then(translations => setText(translations))

  }, [])

  return (<>{text || children || ""}</>)
}

export function $ts({content}) {
  const [activeLang, setActiveLang] = useState()

  if(!content.hasOwnProperty($language().$language()))
    console.warn("$ts: Fill the language")

  return  content.hasOwnProperty($language().$language()) ? content[$language().$language()] : ""

}
export function $language() {
  return Languages.get()
}